var _path, _path2, _path3, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefectElectricCuLegaturaLaPamant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 81,
    viewBox: "0 0 76 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9999 33.997L38.1613 1.02844",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2559 34.707L54.0005 28.9984",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7822 61.6259C42.0166 62.1259 42.6121 62.3411 43.1121 62.1067L51.2606 58.2854C51.7607 58.0509 51.9759 57.4555 51.7414 56.9554C51.5069 56.4554 50.9115 56.2401 50.4115 56.4746L43.1683 59.8713L39.7717 52.6282C39.5372 52.1282 38.9417 51.9129 38.4417 52.1474C37.9417 52.3819 37.7264 52.9773 37.9609 53.4774L41.7822 61.6259ZM53.6122 28.0408L41.7471 60.8613L43.628 61.5412L55.4931 28.7208L53.6122 28.0408Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 63.5,
    x2: 61,
    y2: 63.5,
    stroke: "black",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 68,
    x2: 52,
    y2: 68,
    stroke: "black",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 31,
    y1: 72,
    x2: 46,
    y2: 72,
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefectElectricCuLegaturaLaPamant);
export default __webpack_public_path__ + "static/media/defect_electric_cu_legatura_la_pamant.9d4a23d178ba274f65313a43f0720abd.svg";
export { ForwardRef as ReactComponent };